import { useEffect, useState } from 'react'

type Options = {
  /** Poniżej tej odległości nagłówek zawsze widoczny. */
  minScrollY?: number
  /** Ignoruj drobne ruchy scrolla (px). */
  threshold?: number
  /** Wymuś widoczność (np. otwarte menu mobilne). */
  forceVisible?: boolean
}

export function useScrollHeaderHide({
  minScrollY = 72,
  threshold = 8,
  forceVisible = false,
}: Options = {}): boolean {
  const [hidden, setHidden] = useState(false)

  useEffect(() => {
    if (forceVisible) {
      queueMicrotask(() => setHidden(false))
      return
    }

    let lastY = window.scrollY

    const onScroll = () => {
      const y = window.scrollY
      const delta = y - lastY

      if (Math.abs(delta) < threshold) return

      if (y < minScrollY) {
        setHidden(false)
      } else if (delta > 0) {
        setHidden(true)
      } else {
        setHidden(false)
      }

      lastY = y
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [minScrollY, threshold, forceVisible])

  return hidden
}
